import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ChangePhoneNumberBlockData from '../../../Models/Content/ChangePhoneNumberBlockData';
import ChangePhoneNumberMain from './ChangePhoneNumberMain';
import './changePhoneNumber.scss';

export default class ChangePhoneNumberBlock extends EpiComponent<ChangePhoneNumberBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return (
      <div>
        <ChangePhoneNumberMain context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
